__turbopack_context__.v({
  "challengeCell": "AiInRecruitingChallengesSection-module__IFyTKa__challengeCell",
  "challengesSection": "AiInRecruitingChallengesSection-module__IFyTKa__challengesSection",
  "headerChallenge": "AiInRecruitingChallengesSection-module__IFyTKa__headerChallenge",
  "headerRow": "AiInRecruitingChallengesSection-module__IFyTKa__headerRow",
  "headerSolution": "AiInRecruitingChallengesSection-module__IFyTKa__headerSolution",
  "mainTitle": "AiInRecruitingChallengesSection-module__IFyTKa__mainTitle",
  "row": "AiInRecruitingChallengesSection-module__IFyTKa__row",
  "sectionTitle": "AiInRecruitingChallengesSection-module__IFyTKa__sectionTitle",
  "solutionCell": "AiInRecruitingChallengesSection-module__IFyTKa__solutionCell",
  "subtitle": "AiInRecruitingChallengesSection-module__IFyTKa__subtitle",
  "table": "AiInRecruitingChallengesSection-module__IFyTKa__table",
  "tableOuter": "AiInRecruitingChallengesSection-module__IFyTKa__tableOuter",
  "tableWrapper": "AiInRecruitingChallengesSection-module__IFyTKa__tableWrapper",
});
